import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export interface UserProfileSyncEvent {
  type: 'profile-updated';
  payload?: any;
}

@Injectable({ providedIn: 'root' })
export class UserProfileSyncService {
  private eventSource = new BehaviorSubject<UserProfileSyncEvent | null>(null);
  private eventSubject = new Subject<UserProfileSyncEvent>();
  event$ = this.eventSource.asObservable();

  notifyProfileUpdated(payload?: any) {
    this.eventSource.next({ type: 'profile-updated', payload });
  }
}
